define(
	'app/ui/listing/event',[
		'jquery',

		'util/core',

		'throttledebounce'
	],

	function ($, util) {
		var delay = 500; // ms

		var $list;

		var classes = {
			datepickerDummy: 'js-event-filter-datepicker-dummy'
		};

		var selectors = Object.freeze({
			form: '.js-event-filter-form',
			input: '.js-event-filter-input:not(.' + classes.datepickerDummy + ')',
			datepicker: '.js-filter-datepicker',
			datepickerDummy: '.' + classes.datepickerDummy,
			filterOption: '.js-filter-option',

			wrapper: '.js-event-listing',
			paginationLink: '.js-pagination-link'
		});

		var dataAttributes = Object.freeze({
			ajaxUrl: 'ajax-url'
		});

		var Event = {
			init: function ($el) {
				$list = $el;

				Event._initDatepickerDummyEvent();
				Event._initEvents();
			},

			_initDatepickerDummyEvent: function () {
				var $datepickers = $list.find(selectors.datepicker);

				// When datepickers are initialised, if they have a value,
				// the change event gets fired automatically. This module
				// should ignore those initial change events

				$datepickers.each(function () {
					var $datepicker = $(this);

					if ($datepicker.val()) {
						$datepicker.addClass(classes.datepickerDummy);
					}
				});
			},

			_initEvents: function () {
				$list.on('change', selectors.input, $.debounce(delay, Event._changeEvent));
				$list.on('change', selectors.datepickerDummy, Event._datepickerFirstChangeEvent);
				$list.on('click', selectors.filterOption, Event._removeFilterOption);

				$list.on('click', selectors.paginationLink, Event._paginationClick);
			},

			_changeEvent: function (e) {
				var $form = $(e.target).closest(selectors.form);

				Event._applyFilter($form);
			},

			_datepickerFirstChangeEvent: function (e) {
				var $datepicker = $(e.target);

				$datepicker.removeClass(classes.datepickerDummy);
			},

			_removeFilterOption: function (event) {
				event.preventDefault();
				var $option = $(this);
				var filterName = $option.data('filter-name');

				if (filterName !== '') {
					var $dropdown = $('[name="' + filterName + '"]');

					if ($dropdown.length) {
						$dropdown.find('option').eq(0).prop('selected', true);
						$dropdown.trigger('change');
						$option.empty().remove();
					}
				}
			},

			_applyFilter: function ($form) {
				$form.submit();
			},

			_paginationClick: function (e) {
				e.preventDefault();

				var $paginationLink = $(e.target).closest(selectors.paginationLink);
				var $wrapper = $paginationLink.closest(selectors.wrapper);

				var ajaxUrl = $wrapper.data(dataAttributes.ajaxUrl);
				var paginationUrl = $paginationLink.attr('href');

				var fullAjaxUrl = ajaxUrl + paginationUrl;

				$.ajax({
					url: fullAjaxUrl,
					method: 'GET',
					complete: Event._paginationComplete($wrapper),
					success: Event._paginationSuccess($wrapper),
					error: Event._paginationError($wrapper)
				});
			},

			_paginationComplete: function ($wrapper) {
				return function () {
					// console.info(Array.from(arguments));
				};
			},

			_paginationSuccess: function ($wrapper) {
				return function (response) {
					// console.log(Array.from(arguments);
					$wrapper.html(response);

					util.scrollToElm($wrapper);
				};
			},

			_paginationError: function ($wrapper) {
				return function () {
					// console.error(Array.from(arguments));
				}
			}
		};

		return {
			init: Event.init
		};
	}
);
